import { PriceItemListCombinedProps } from './types';

const usePresenter = (props: PriceItemListCombinedProps): PriceItemListCombinedProps => {
  return props;
};

export default usePresenter;
